/* eslint-disable no-param-reassign */
const module = {
  namespaced: true,
  state: {
    isLoading: false,
  },
  mutations: {
    updateIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    }
  }
}

export default module;
